import styles from './CorrectedSearchTerm.module.scss';

const NOT_STOCKED_SUBSTITUTE = 'NotStockedSubstitute';
const SPELL_CORRECT = 'SpellCorrect';
const SUBSTITUTE = 'Substitute';

const allowedCorrectionTypes = [
  NOT_STOCKED_SUBSTITUTE,
  SPELL_CORRECT,
  SUBSTITUTE,
];

export type Props = {
  correctedSearchTerm?: string;
  totalNumberOfResults?: number;
  originalSearchTerm?: string;
  correctionType?: string;
};

export const CorrectedSearchTerm = ({
  correctedSearchTerm,
  totalNumberOfResults = 0,
  originalSearchTerm,
  correctionType,
}: Props) => {
  if (
    !allowedCorrectionTypes.includes(correctionType) ||
    (!correctedSearchTerm && correctionType !== NOT_STOCKED_SUBSTITUTE)
  ) {
    return null;
  }

  let copy;

  if (correctionType === NOT_STOCKED_SUBSTITUTE && totalNumberOfResults > 0) {
    copy = correctedSearchTerm
      ? `Sorry, we don't stock ${originalSearchTerm}. Here are ${totalNumberOfResults} results for ${correctedSearchTerm}.`
      : `Sorry, we don't stock ${originalSearchTerm}. Here are ${totalNumberOfResults} similar products.`;
  } else {
    copy = `Showing ${totalNumberOfResults} result${
      totalNumberOfResults !== 1 ? 's' : ''
    } for '${correctedSearchTerm}'`;
  }

  return (
    <div
      data-testid="corrected-search-term"
      className={styles['corrected-search-term']}
    >
      <p
        data-testid="corrected-search-term-copy"
        className={styles['corrected-search-term__copy']}
      >
        {copy}
      </p>
    </div>
  );
};
